import { getPromoManager, getPromoManagerSync } from '@mail/3promo/utils';

export { getPromoManager, getPromoManagerSync };

/**
 * Обновляем менеджер и проверяет, есть ли промо в обработке менеджера
 * @returns есть ли промо в обработке менеджера
 */
export const updatePromoManager = async () => {
    const manager = getPromoManagerSync();
    if (!manager) {
        return false;
    }
    await manager.update();
    return manager.hasActiveItem();
};
